import * as React from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { Avatar, IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import { UserState, selectUser } from "../../redux/user/userSlice";
import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { deepPurple } from "@mui/material/colors";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { assertThumbnailUrl } from "../../redux/common";
import { auth } from "../../firebase/FirebaseConfig";

let token = undefined as string | undefined;
export function isTokenReady(user: UserState) {
    token = user.token;
    if (user.token)
        return true;
    return false;
}

export function getToken() {
    return token;
}

export default function UserAvatar() {
    const user = useSelector(selectUser);
       const signOut = (event: any) => {
        event.preventDefault();
        try {
            setOpenMenu(false);
            console.log(" ++++++ Signing out ++++++++");
            auth.signOut().then(() => {
                console.log(" ++++++ Signed out ++++++++");
            }).catch((error) => {
                console.error("Error signing out", error);
            });
        } catch (error) {
            console.error("Error signing out", error);
        }
    };

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [openMenu, setOpenMenu] = React.useState(false);

    // const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        setOpenMenu(true);
    };
    const handleClose = () => {
        console.log("handleClose");
        setOpenMenu(false);
        // setAnchorEl(null);
    };

    const vuser = () => {
        switch (user.state) {
            case "in":
                const imageUrl = assertThumbnailUrl(user?.firebase?.photoURL);
                return (
                    <Box height={50} width={65} display="flex" alignItems="center" justifyContent="center" gap={0} p={0} >
                        <IconButton onClick={handleClick}>
                            <Avatar sx={{ bgcolor: deepPurple[500] }} alt={`${user?.firebase?.displayName}`} src={`${imageUrl}`} />
                        </IconButton>
                        <Menu id="basic-menu" anchorEl={anchorEl} open={openMenu} onClose={handleClose} MenuListProps={{ "aria-labelledby": "basic-button", }}>
                            <MenuItem onClick={signOut}>Logout</MenuItem>
                        </Menu>
                    </Box>
                );
            case "off":
                return (<LoginButton />);
            default:
                return (<Box> <CircularProgress size={20} /> </Box>);
        }
    };

    return (
        <Box height={50} width={65} display="flex" alignItems="center" justifyContent="center" gap={0} p={0} sx={{ border: "1px transparent black" }} >
            {vuser()}
        </Box>
    );
}

export function LoginButton() {
    const signIn = (event: any) => {
        event.preventDefault();
        signInWithGoogle();
    };
    return <Button onClick={signIn} variant="contained" size="small">Entrar</Button>;
}

// let listeningChange = false;

let open = false;
export async function signInWithGoogle() {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
        prompt: "select_account"
    });
    try {
        console.debug("Do the login");
        if (!open) {
            open = true;
            await signInWithPopup(auth, provider);
            console.debug("Login done");
        }
    } catch (error) {
        console.error("Error signing in with Google", error);
    }

    open = false;
}


